import React, { useState } from 'react';

import { useProcurement } from '../context/ProcurementContext';
import { PROCUREMENT_TABS, initialTabId } from '../procurementTabs';

import ApprovalsTab from './ApprovalsTab';
import OverviewTab from './OverviewTab';
import PlanTab from './PlanTab';
import SetupTab from './SetupTab';

import Tabs, { RenderStrategyOnFirstVisit } from 'CommonComponents/Tabs';

/**
 * IB-699 — the redesigned Procurement "face": four tabs (Overview · Plan · Approvals · Setup)
 * replacing the previous eight. Overview (IB-699), Plan (IB-700) and Approvals + Setup (IB-701)
 * are all built here.
 *
 * Rendered only when the `ProcurementRedesign` feature flag is on (see ProcurementIndex).
 */
const ProcurementFace = () => {
    const { settings } = useProcurement();

    const tabs = [
        {
            id: PROCUREMENT_TABS.OVERVIEW,
            title: $t('Overview'),
            content: () => <OverviewTab />,
        },
        {
            id: PROCUREMENT_TABS.PLAN,
            title: $t('Plan'),
            content: () => <PlanTab />,
        },
        {
            id: PROCUREMENT_TABS.APPROVALS,
            title: $t('Approvals'),
            content: () => <ApprovalsTab />,
        },
        {
            id: PROCUREMENT_TABS.SETUP,
            title: $t('Setup'),
            content: () => <SetupTab />,
        },
    ];

    const [activeTab, setActiveTab] = useState(() => initialTabId(tabs, settings.activeTabId, PROCUREMENT_TABS.OVERVIEW));

    return <Tabs tabs={tabs} activeTab={activeTab} onTabActivate={setActiveTab} renderStrategy={RenderStrategyOnFirstVisit} />;
};

export default ProcurementFace;
